import React, { useState, useEffect, useCallback } from 'react';
import TableWrapper from '../../components/Grid';

import { Avatar, Col, Row, Form, Divider, Tooltip, Spin } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import {
    LoadingOutlined,
    UserOutlined,
    PlusOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { FaFilter } from 'react-icons/fa6';
import { TextField, ScrollEndMessage } from '../../components';
import BasicText from '../../components/Text/BasicText';
import DropDown from '../../components/DropDown';
import SelectField from '../../components/TextField/SelectField';
import { AddUserSchema } from '../../config/Schema';
import moment from 'moment';
// import LoadingOutlined from 'react-icons/ai'
// import AiOutlineSearch from 'react-icons/ai'
// import { Avatar } from '../../components';
import { AiOutlineLoading } from 'react-icons/ai';
import { LuUser } from 'react-icons/lu';
import { FaCamera } from 'react-icons/fa';
import { FaEye } from 'react-icons/fa';
import { FaBan } from 'react-icons/fa';
import { IoIosPower } from 'react-icons/io';
import { CiEdit } from 'react-icons/ci';
import camera from '../../assets/images/camera.png';

// import { TextField } from '../../components';
import BasicDrawaer from '../../components/Drawer';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AdduserForm } from '../../config/Schema';
import LabelWithField from '../../components/LabelWithField';
import LabelWithSelect from '../../components/LabelWithSelect';
import LabelWithDate from '../../components/LabelWithDate';
import Button from '../../components/Button';
import Text from '../../components/Text';
import { Colors } from '../../config';
import {
    getEligibiity,
    getSchedules,
    getUserRoles,
} from '../../config/getApis';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { UserManagementAction } from '../../store/actions';
import { useNavigate } from 'react-router';
// import { Spin } from 'antd';
import Circular from '../../components/Loader/Circular';
import ButtonLoader from '../../components/Button/ButtonLoader';
import dayjs from 'dayjs';
import ActionDropdown from '../../components/DropDown/actiondropdown';
import UserDetailDrawer from './UserDetailDrawer';
import UserAddnEditDrawer from './UserAddnEditDrawer';
import useColors from '../../hooks/useColors';
import { phoneNumberFormat } from '../../config/util/PhoneNumberFormatter';


const UserMangement = () => {
    const dispatch = useDispatch();

    const userData = useSelector(
        (state) => state?.UserManagementReducer?.UserData,
    );
    const loader = useSelector((state) => state?.UserManagementReducer?.loader);
    const usersError = useSelector((state) => state?.UserManagementReducer?.usersError);
    const userDetailData = useSelector(
        (state) => state?.UserManagementReducer?.UserDetailData,
    );
    const userAddLoader = useSelector(
        (state) => state?.UserManagementReducer?.AddUserLoader,
    );
    const userDetailLoader = useSelector(
        (state) => state?.UserManagementReducer?.DetailUserLoader,
    );
    const user = useSelector((state) => state.AppReducer?.user);
    const isRole = user?.userRole[0];
    console.log(isRole, "isRole");

    const { colorPrimary } = useColors();

    const { data: eligibilityData } = useQuery('eligibility', getEligibiity);
    const { data: scheduleData } = useQuery('schedules', getSchedules);
    const { data: rolesData } = useQuery('roles', getUserRoles);

    const [state, setState] = useState({
        current: 1,
        limit: 20,
        searchVal: '',
        tabName: 'active',
        roleType: '',
        scheduleId: '',
        sortBy: 'firstName',
        sortOrder: 'asc',
    });

    const STATUS_OPTIONS = [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inActive' },
        { label: 'All', value: '' },
    ];

    const handleStatusChange = (value) => {
        console.log(value, "value tab Name");
        setSearchTerm('');
        setAccumulatedUsers([]);
        setState((prev) => ({
            ...prev,
            current: 1,
            searchVal: '',
            tabName: value,
            roleType: '',
            scheduleId: '',
        }));
    };

    const toggleSort = () => {
        setState((prev) => ({
            ...prev,
            current: 1,
            sortOrder: prev.sortOrder === 'asc' ? 'desc' : 'asc',
        }));
    };

    const [searchTerm, setSearchTerm] = useState('');
    const [accumulatedUsers, setAccumulatedUsers] = useState([]);
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setState((prev) => ({
                ...prev,
                current: 1,
                searchVal: searchTerm,
            }));
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    useEffect(() => {
        dispatch(UserManagementAction.GetUsers(state));
    }, [
        state.current,
        state.limit,
        state.searchVal,
        state.tabName,
        state.roleType,
        state.scheduleId,
        state.sortBy,
        state.sortOrder,
    ]);

    useEffect(() => {
        setAccumulatedUsers([]);
    }, [state.tabName, state.roleType, state.scheduleId, state.searchVal, state.sortBy, state.sortOrder]);

    useEffect(() => {
        if (userData?.data?.data) {
            if (state.current === 1) {
                setAccumulatedUsers(userData.data.data);
            } else {
                setAccumulatedUsers((prev) => {
                    const existingIds = new Set(prev.map((u) => u.id));
                    const newUsers = userData.data.data.filter((u) => !existingIds.has(u.id));
                    return [...prev, ...newUsers];
                });
            }
        }
    }, [userData, state.current]);

    useEffect(() => {
        if (usersError) {
            setAccumulatedUsers([]);
        }
    }, [usersError]);

    const paginate = userData?.data?.paginate;

    const hasMore = paginate ? (paginate.currentPage < paginate.lastPage) : true;
    console.log(paginate?.currentPage, paginate?.lastPage, hasMore, 'paginate');

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (!container) return;

        const handleScroll = () => {
            const isNearBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 100;
            if (isNearBottom && !loader && hasMore) {
                setState((prev) => ({
                    ...prev,
                    current: prev.current + 1,
                }));
            }
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [loader, hasMore]);

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (container) {
            container.scrollTop = 0;
        }
    }, [state.tabName]);

    const sortedUsers = React.useMemo(() => {
        if (!accumulatedUsers) return [];
        return [...accumulatedUsers].sort((a, b) => {
            const nameA = `${a?.username || ''}`.trim().toLowerCase();
            const nameB = `${b?.username || ''}`.trim().toLowerCase();
            return nameA.localeCompare(nameB);
        });
    }, [accumulatedUsers]);

    const filteredUsers = React.useMemo(() => {
        let list = sortedUsers;
        if (state.scheduleId) {
            list = list.filter((user) =>
                user?.schedules?.some((s) => s.id === Number(state.scheduleId))
            );
        }
        return list;
    }, [sortedUsers, state.scheduleId]);

    const scheduleFilterValues = React.useMemo(() => {
        const base = [{ label: 'All Schedules', value: '' }];
        if (scheduleData) {
            return [...base, ...scheduleData];
        }
        return base;
    }, [scheduleData]);




    if (rolesData && isRole === 'manager') {
        for (let i = 0; i < rolesData.length; i++) {
            if (rolesData[i]?.label === 'admin') {
                rolesData.splice(i, 1);
                i--;
            }
        }
    }

    // img work
    const [img, setimg] = useState(null);
    const [readFile, setReadFile] = useState(null);

    // Drawers maintaining states.
    const [drawerStates, setDrawerStates] = useState({
        openDrawer: false,
        userDetailDrawer: false,
        drawerkey: null,
        userid: null,
    });

    // Image Validation handling
    const [imgValue, setImageValue] = useState({
        imgSizeValidation: '',
        imgTypeValidation: '',
        isRequired: '',
    });

    // Tab Change handling (now handled via dropdown)
    const tabChange = (key) => {
        const tabName = key == 1 ? 'active' : 'inActive';
        setSearchTerm('');
        setState((prev) => ({
            ...prev,
            current: 1,
            limit: 20,
            searchVal: '',
            tabName: tabName,
            roleType: '',
            scheduleId: '',
        }));
    };

    // Add user Drawer
    const onCloseDrawer = () => {
        console.log('onCloseDrawer', drawerStates);

        if (drawerStates?.drawerkey == 1 && drawerStates.userDetailDrawer) {
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: false,
                drawerkey: null,
                userid: null,
            });
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            reset();
        } else {
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: false,
                userid: null,
            });
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            dispatch(UserManagementAction.UserDetailReset());
            reset();
        }
    };

    // this will run only after closing of Add or Edit drawer.
    // the purpose of using this only in add or edit drawer case is becasue when user click on details
    // the drawer key is set to 1 which discriminate Add user or Edit user but the Edit drawer will only
    // open when the openDrawer state is true and this will happen only when user clicked on edit button
    // so it will maintain the drawer key which is 1 and open edit modal but on click of close btn
    // the state is getting set to drawer key = null again which is default so by doing so it rapidly changes
    // the drawer text from edit drawer to Add drawer as the condition goes if drawerKey == null ? Ádd': 'Edit'.
    // so that is why this function is used and handled different cases as well.
    const drawerKeyHandler = (isOpen, reset) => {
        if (!isOpen) {
            setDrawerStates({ ...state, drawerkey: null });
            setReadFile(null);
            reset();
        }
    };

    // this will run only after closing of detail drawer.
    const detailDrawerReset = (isOpen) => {
        if (!isOpen && !drawerStates.openDrawer) {
            dispatch(UserManagementAction.UserDetailReset());
        }
    };

    // Form related Working
    let schema = AddUserSchema;
    const {
        handleSubmit,
        control,
        reset,
        setValue,
        watch,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        // mode: 'onChange'
    });

    // form data
    const FormDataHandler = (data) => {
        console.log("Incoming Data:", data);


        const file = watch(data?.userimg);

        if (Object.keys(errors).length > 0) {
            setError('phoneNo', {
                type: 'format',
                message: errors?.phoneNo?.message,
            });
            return;
        } else if (imgValue?.imgSizeValidation || imgValue.imgTypeValidation) {
            return;
        }

        //setting the key null is important as when the buttons inside the drawers clicked the key is already
        //select to 1 from the dropdown selection and for the future actions it will remain 1 if we didn't -
        //handle it.
        else {
            if (drawerStates.drawerkey == 1) {
                // for dispatching form action about UPDATE USER CASE.
                // for dispatching form action about UPDATE USER CASE.
                // let certificationInfo = {};
                // for (const key in data) {
                //     if (data[key] instanceof Date) {
                //         certificationInfo[key] = moment(data[key]).format(
                //             'DD-MM-YYYY',
                //         );
                //         delete data[key];
                //     }
                // }

                // data['certificationInfo'] = certificationInfo;
                if (!data['certificationInfo']) {
                    let certificationInfo = {};
                    for (const key in data) {
                        if (data[key] instanceof Date) {
                            certificationInfo[key] = moment(data[key]).format(
                                'DD-MM-YYYY',
                            );
                            delete data[key];
                        }
                    }
                    data['certificationInfo'] = certificationInfo;
                }
                const id = Number(drawerStates?.userid);

                data['certificationInfo'] &&
                    dispatch(
                        UserManagementAction.UpdateUser(data, id, () => {
                            dispatch(UserManagementAction.UserDetailReset());
                            setDrawerStates({
                                ...drawerStates,
                                openDrawer: false,
                                userDetailDrawer: false,
                                drawerkey: null,
                            });
                            reset();
                            setReadFile(null);
                            setState((prev) => ({ ...prev, current: 1 }));
                            if (state.current === 1) {
                                dispatch(UserManagementAction.GetUsers({ ...state, current: 1 }));
                            }
                        }),
                    );
                return;
            } else {
                // for dispatching form action about ADD USER CASE.
                // setting an object, as api expects date in a different objects so modifying for it.

                // let certificationInfo = {};
                // for (const key in data) {
                //     if (data[key] instanceof Date) {
                //         certificationInfo[key] = moment(data[key]).format(
                //             'DD-MM-YYYY',
                //         );
                //         delete data[key];
                //     }
                // }

                // data['certificationInfo'] = certificationInfo;

                // if certificationInfo contain some data i.e dates so we'll dispatch an actions only.

                dispatch(
                    UserManagementAction.AddUsers(data, () => {
                        setDrawerStates({
                            ...drawerStates,
                            openDrawer: false,
                            userDetailDrawer: false,
                            drawerkey: null,
                        });
                        reset();
                        setReadFile(null);
                        setState((prev) => ({ ...prev, current: 1 }));
                        if (state.current === 1) {
                            dispatch(UserManagementAction.GetUsers({ ...state, current: 1 }));
                        }
                    }),
                );
            }

            return;
        }
    };

    // user Select values filter handler
    const SelectFilterHandler = (value) => {
        setState((prev) => ({
            ...prev,
            current: 1,
            roleType: value,
        }));
    };

    // user Select Values
    const SelectFilterValues = [
        {
            value: 'admin',
            label: 'Admin',
        },
        {
            value: 'supervisor',
            label: 'Supervisor',
        },
        {
            value: 'guard',
            label: 'Guard',
        },
        {
            value: 'manager',
            label: 'Manager',
        },
        {
            value: '',
            label: 'View All',
        },
    ];

    // user search bar filter handler
    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // items for Action.
    // items for Action.
    const items = [
        {
            label: 'View and Edit',
            key: 1,
            icon: <FaEye color="#6A9BFF" />,
            backgroundColor: '#eef4ff',
            color: '#4582ff',
        },
        {
            label: state?.tabName == 'active' ? 'Deactivate' : 'Activate',
            key: 2,
            icon:
                state?.tabName == 'active' ? (
                    <FaBan color="red" />
                ) : (
                    <IoIosPower size={15} />
                ),
            backgroundColor: state?.tabName == 'active' ? '#fef3f5' : '#D5EBD9',
            color: state?.tabName == 'active' ? '#e93148' : '#7FC18D',
        },
    ];
    // for Action dropdown
    const ActionHandler = (e, record) => {
        const { current, limit, searchVal } = state;

        if (e.key == '1') {
            let payload = {
                id: Number(record?.id),
            };
            setDrawerStates({
                ...drawerStates,
                openDrawer: false,
                userDetailDrawer: true,
                drawerkey: 1,
                userid: record?.id,
            });
            dispatch(
                UserManagementAction.GetUserDetail(payload, () => {
                    setState({
                        ...state,
                        current: current,
                        limit: limit,
                        searchVal: searchVal,
                    });
                }),
            );
        } else {
            // for inactivating or activating user.
            if (state?.tabName == 'active') {
                let payload = {
                    id: Number(record?.id),
                    status: 'inActive',
                };
                dispatch(
                    UserManagementAction.UpdateUserStatus(payload, () => {
                        setState((prev) => ({ ...prev, current: 1 }));
                        if (state.current === 1) {
                            dispatch(UserManagementAction.GetUsers({ ...state, current: 1 }));
                        }
                    }),
                );
            } else {
                let payload = {
                    id: Number(record?.id),
                    status: 'active',
                };
                dispatch(
                    UserManagementAction.UpdateUserStatus(payload, () => {
                        setState((prev) => ({ ...prev, current: 1 }));
                        if (state.current === 1) {
                            dispatch(UserManagementAction.GetUsers({ ...state, current: 1 }));
                        }
                    }),
                );
            }
        }
    };

    const handleRowClick = (record) => {
        const { current, limit, searchVal } = state;
        let payload = {
            id: Number(record?.id),
        };
        setDrawerStates({
            ...drawerStates,
            openDrawer: false,
            userDetailDrawer: true,
            drawerkey: 1,
            userid: record?.id,
        });
        dispatch(
            UserManagementAction.GetUserDetail(payload, () => {
                setState({
                    ...state,
                    current: current,
                    limit: limit,
                    searchVal: searchVal,
                });
            }),
        );
    };

    // edit user button-handler in a drawer
    const UserEditHandler = () => {
        console.log(drawerStates);
        setDrawerStates({
            ...drawerStates,
            userDetailDrawer: false,
            openDrawer: true,
        });
        if (userDetailData?.profileImg[0]?.url) {
            setReadFile(userDetailData?.profileImg[0]?.url);
        }
        // reset(userDetailData)
    };

    // Add New User handler
    const AddUserHandler = () => {
        if (readFile) {
            setReadFile(null);
            setDrawerStates({
                ...drawerStates,
                userDetailDrawer: false,
                openDrawer: true,
            });
        } else {
            setDrawerStates({
                ...drawerStates,
                userDetailDrawer: false,
                openDrawer: true,
            });
        }
    };

    // ACTIVE USERS COLUMNS
    const columns = [
        {
            title: (
                <div
                    style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', userSelect: 'none' }}
                    onClick={toggleSort}
                >
                    <span>User Name</span>
                    <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                        <CaretUpOutlined style={{ fontSize: 10, color: state.sortOrder === 'asc' ? colorPrimary : '#bbb' }} />
                        <CaretDownOutlined style={{ fontSize: 10, color: state.sortOrder === 'desc' ? colorPrimary : '#bbb' }} />
                    </span>
                </div>
            ),
            dataIndex: 'userName',
            align: 'left',
            render: (text, record) => (
                <Row
                    justify={'center'}
                    style={{ display: 'flex', alignItems: 'center' }}
                >
                    <Col span={24} className="flex justify-start items-center">
                        {record?.profileImg[0]?.url ? (
                            <Avatar
                                className="mr-5"
                                size={40}
                                src={record?.profileImg[0]?.url}
                            />
                        ) : (
                            <Avatar
                                className="mr-5"
                                size={40}
                                icon={<UserOutlined />}
                            />
                        )}
                        <span>
                            {record?.firstName + ' ' + record?.lastName}
                        </span>
                    </Col>
                </Row>
            ),
        },
        {
            title: 'Phone#',
            dataIndex: 'phoneNo',
            key: 'phone',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.phoneNo}</span>
                    </Col>
                );
            },
        },
        {
            title: 'Role',
            dataIndex: 'userRole',
            key: 'role',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <span>{record?.userRole[0]?.name}</span>
                    </Col>
                );
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="w-full flex justify-start align-center flex-wrap"
                    >
                        <span className="break-all">{record?.email}</span>
                    </Col>
                );
            },
        },

        {
            title: 'Position',
            dataIndex: 'eligibilities',
            key: 'elegibility',
            render: (text, record) => {
                const eligibilityNames = record?.eligibilities
                    ?.map((eligibility) => eligibility.name)
                    .join(', ');
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <Tooltip
                            placement="bottom"
                            title={`${eligibilityNames}`}
                        >
                            <span className="">
                                {record?.eligibilities[0]?.name
                                    ? record?.eligibilities[0]?.name
                                    : '-'}
                            </span>
                        </Tooltip>
                    </Col>
                );
            },
        },

        {
            title: 'Schedules',
            dataIndex: 'schedules',
            key: 'schedules',
            render: (text, record) => {
                const scheduleNames = record?.schedules
                    ?.map((schedule) => schedule.name)
                    .join(', ');
                return (
                    <Col span={24} className="flex justify-start align-center">
                        <Tooltip placement="bottom" title={`${scheduleNames}`}>
                            <span className="">
                                {record?.schedules[0]?.name
                                    ? record?.schedules[0]?.name
                                    : '-'}
                            </span>
                        </Tooltip>
                    </Col>
                );
            },
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-center align-center"
                        style={{}}
                    >
                        <ActionDropdown
                            items={items}
                            placement={'bottom'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => ActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];

    const handlePaginationChange = (page, pageSize) => {
        console.log(page, pageSize);
        dispatch(
            UserManagementAction.GetUsers({
                ...state,
                current: page,
                limit: pageSize,
            }),
        );
        setState({ ...state, current: page, limit: pageSize });
        return;
    };

    // const phoneNumberFormat = (number) => {
    //     const cleaned = ('', number).replace(/\D/g, '');
    //     let phoneNumber;

    //     if (cleaned.length === 10) {
    //         return (phoneNumber =
    //             '(' +
    //             cleaned.substr(0, 3) +
    //             ') ' +
    //             cleaned.substr(3, 3) +
    //             '-' +
    //             cleaned.substr(6, 4));
    //     } else {
    //         return;
    //     }
    // };

    return (
        <>
            <UserAddnEditDrawer
                drawerStates={drawerStates}
                drawerKeyHandler={drawerKeyHandler}
                onCloseDrawer={onCloseDrawer}
                userDetailData={userDetailData}
                phoneNumberFormat={phoneNumberFormat}
                FormDataHandler={FormDataHandler}
                userAddLoader={userAddLoader}
                eligibilityData={eligibilityData}
                scheduleData={scheduleData}
                rolesData={rolesData}
                img={img}
                setimg={setimg}
                imgValue={imgValue}
                setImageValue={setImageValue}
                readFile={readFile}
                setReadFile={setReadFile}
            />

            <UserDetailDrawer
                onCloseDrawer={onCloseDrawer}
                detailDrawerReset={detailDrawerReset}
                drawerStates={drawerStates}
                userDetailLoader={userDetailLoader}
                userDetailData={userDetailData}
                UserEditHandler={UserEditHandler}
                isRole={isRole}
            />

            <div className="w-full flex items-center justify-between gap-3 my-4" style={{ flexWrap: 'wrap' }}>
                <h1 className="text-xl font-semibold m-0" style={{ flexShrink: 0 }}>User Management</h1>
                <div className="flex items-center gap-3" style={{ flexShrink: 0 }}>
                    <div style={{ width: '260px' }}>
                        <TextField.Basic
                            style={{ background: '#eff2f5', width: '100%', margin: 0 }}
                            suffix={<SearchOutlined style={{ fontSize: '18px', color: '#888' }} />}
                            placeholder="Search..."
                            onChange={(e) => handleInputChange(e)}
                            id="search"
                            name="search"
                            value={searchTerm}
                            className="placeholder-red outline-none w-full py-2 px-4"
                        />
                    </div>

                    <button
                        type="button"
                        aria-label="Open filters"
                        onClick={() => setFilterDrawerOpen(true)}
                        style={{
                            width: '40px',
                            height: '40px',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#eff2f5',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                        }}
                    >
                        <FaFilter color="white"
                            style={{ background: colorPrimary, flexShrink: 0, height: 38, width: 38, }}
                            className="cursor-pointer p-2 rounded-md" />
                    </button>

                    {(isRole === 'admin' || isRole === 'manager') && (
                        <Button.Basic
                            className="text-white outline-none border-none cursor-pointer"
                            style={{
                                height: '40px',
                                flexShrink: 0,
                                background: colorPrimary,
                                color: Colors.White,
                                paddingLeft: '20px',
                                paddingRight: '20px',
                                borderRadius: '8px',
                                fontWeight: 500,
                                letterSpacing: '0.3px',
                            }}
                            text="Add New User"
                            icon={<PlusOutlined />}
                            onClick={() => AddUserHandler && AddUserHandler()}
                        />
                    )}
                </div>
            </div>

            <BasicDrawaer
                title="Filters"
                openDrawer={filterDrawerOpen}
                onClose={() => setFilterDrawerOpen(false)}
                width={340}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                        <p className="mb-2 text-sm font-medium text-gray-600">View All</p>
                        <SelectField
                            defaultValue={''}
                            style={{ backgroundColor: '#eff2f5' }}
                            className="w-full h-10"
                            onChange={(val) => SelectFilterHandler && SelectFilterHandler(val)}
                            options={SelectFilterValues}
                            placeholder="View All"
                        />
                    </div>

                    <div>
                        <p className="mb-2 text-sm font-medium text-gray-600">All Schedules</p>
                        <SelectField
                            value={state.scheduleId}
                            style={{ backgroundColor: '#eff2f5' }}
                            className="w-full h-10"
                            onChange={(val) => setState((prev) => ({ ...prev, current: 1, scheduleId: val }))}
                            options={scheduleFilterValues}
                            placeholder="All Schedules"
                        />
                    </div>

                    <div>
                        <p className="mb-2 text-sm font-medium text-gray-600">Status</p>
                        <SelectField
                            value={state.tabName}
                            style={{ backgroundColor: '#eff2f5' }}
                            className="w-full h-10"
                            onChange={handleStatusChange}
                            options={STATUS_OPTIONS}
                            placeholder="All"
                        />
                    </div>
                </div>
            </BasicDrawaer>

            <Row
                gutter={[8, 32]}
                className="w-fit sm:w-fit lg:w-fit xl:w-full"
                style={{
                    background: 'white',
                    padding: '16px',
                    borderRadius: '10px',
                }}
            >
                <Col lg={24}>
                    <TableWrapper
                        tableStyle={{
                            borderRadius: '40px',
                            width: '100%',
                        }}
                        headerbg={'red'}
                        tableColumns={columns}
                        tableData={filteredUsers}
                        pagination={false}
                        rowClassName={'row-antd'}
                        onRow={(record) => ({
                            onClick: () => handleRowClick(record),
                        })}
                    />
                    {loader && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                            <Spin />
                        </div>
                    )}
                    <ScrollEndMessage
                        hasMore={hasMore}
                        loading={loader}
                        dataLength={filteredUsers?.length}
                    />
                </Col>
            </Row>
        </>
    );
};

export default UserMangement;
